import { GET_ASSIGNMENT_DETAILS, SET_CURRENT_ASSIGNMENT_ID, SET_TABLE_PAGE } from "../Types/OutboundTypes";

const outboundState = {
  currentAssignmentID: null,
  getAssignmentDetails: true,
  tablePage: 0,
};

export const outboundReducer = (state = outboundState, action) => {
  const { payload, type } = action;

  // This reducer is only used to trigger getAssignmentDetails after editing contact
  if (type === GET_ASSIGNMENT_DETAILS) {
    return {
      ...state,
      getAssignmentDetails: !state.getAssignmentDetails,
    };
  }

  // To store current assignment id
  if (type === SET_CURRENT_ASSIGNMENT_ID) {
    return {
      ...state,
      currentAssignmentID: payload.assignmentID,
    };
  }

  // To save assignment list table page
  if (type === SET_TABLE_PAGE) {
    return {
      ...state,
      tablePage: payload.tablePage,
    };
  }

  return state;
};
